module.exports = __webpack_public_path__ + "img/boston.79917d8.svg";